<section class="content-layout" [brightsideWebFb]="{ event_name: 'survey_intro', custom: { type: surveyData.type} }" *ngIf="surveyData$ | async as surveyData; else spinner">
  <bw-action-article-legacy>
    <ui-nav-exit-back
      back-action-top
      [trackingDetail]="{ event_name: 'survey_intro' }"
      (exitActionHandler)="backToHomePage()"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <img src="../assets/{{ surveyData.intro.image }}.svg" [alt]="surveyData.intro.image" class="mb-md" />
          <typography-legacy text-large-regular color="var(--secondary-text)" class="mb-sm">
            {{
              surveyData.status === SurveyStatus.NOT_STARTED
                ? ('SURVEY_INTRO_GET_STARTED' | translate : { minutes: surveyData.intro.completionEstimate })
                : ('SURVEY_INTRO_ALMOST_DONE' | translate)
            }}
          </typography-legacy>
          <p title-medium class="mb-sm">{{ surveyData.intro.title | translate }}</p>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="left" style="max-width: 432px">
              {{ surveyData.intro.desc | translate }}
            </p>
          </typography-legacy>
        </div>
      </div>
    </div>

    <div footer-actions>
      <button
        *ngIf="surveyData.intro.cta"
        bw-button-legacy
        type="submit"
        [brightsideWebFb]="{ event_name: 'survey_intro' }"
        (click)="startWithSurveyQuestions()"
      >
        {{ surveyData.intro.cta | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
